import * as React from "react";
import type { SVGProps } from "react";
const SvgUploadCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#upload-cloud_svg__a)">
      <path
        fill="currentColor"
        d="M15.293 16.707a1 1 0 0 0 1.414-1.414zM12 12l.707-.707a1 1 0 0 0-1.414 0zm-4.707 3.293a1 1 0 1 0 1.414 1.414zM11 21a1 1 0 1 0 2 0zm8.911-3.488a1 1 0 1 0 .958 1.756zM18 9V8zm-1.26 0-.968.25a1 1 0 0 0 .968.75zM2.25 16.962a1 1 0 0 0 1.5-1.324zm14.457-1.67-4-4-1.414 1.415 4 4zm-5.414-4-4 4 1.414 1.415 4-4zM11 12v9h2v-9zm9.869 7.268a6 6 0 0 0 2.628-2.87l-1.834-.8a4 4 0 0 1-1.752 1.914zm2.628-2.87a6 6 0 0 0 .314-3.878l-1.938.493a4 4 0 0 1-.21 2.586zm.314-3.878a6 6 0 0 0-2.13-3.256l-1.228 1.579a4 4 0 0 1 1.42 2.17zm-2.13-3.256A6 6 0 0 0 18 8l-.002 2a4 4 0 0 1 2.454.843zM18 8h-1.26v2H18zm-.292.75a9 9 0 0 0-1.856-3.577L14.328 6.47a7 7 0 0 1 1.444 2.781zm-1.856-3.577a9 9 0 0 0-3.231-2.408l-.806 1.83a7 7 0 0 1 2.513 1.874zM12.62 2.765a9 9 0 0 0-3.958-.756l.074 1.998a7 7 0 0 1 3.078.589zM8.663 2.01a9 9 0 0 0-3.891 1.046L5.71 4.82a7 7 0 0 1 3.027-.814zM4.772 3.055a9 9 0 0 0-3.045 2.639l1.615 1.18A7 7 0 0 1 5.71 4.82zM1.727 5.694A9 9 0 0 0 .14 9.397l1.968.357a7 7 0 0 1 1.235-2.88zM.14 9.397a9 9 0 0 0 .187 4.025l1.926-.538a7 7 0 0 1-.145-3.13zm.187 4.025a9 9 0 0 0 1.925 3.54l1.498-1.324a7 7 0 0 1-1.497-2.754z"
      />
    </g>
    <defs>
      <clipPath id="upload-cloud_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUploadCloud;
